import { render, staticRenderFns } from "./EmailWithConfirmation.vue?vue&type=template&id=57536dcc"
import script from "./EmailWithConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailWithConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports